/**
 * Common ShowcaseMedia component used by other modules as a reusable component which returns the ui for a ShowcaseMedia card.
 *
 * @module views/Molecules/ShowcaseMedia
 * @memberof -Common
 */
import './ShowcaseMedia.scss';

import React from 'react';

import PropTypes from 'prop-types';
import palette_variables from 'web-styles/src/_exports.module.scss';

import Image from '@ulta/core/components/Image/Image';
import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';

import Button from '@ulta/modules/Button/Button';
import Text from '@ulta/modules/Text/Text';
/**
 * Represents a ShowcaseMedia component
 *
 * @method
 * @param {ShowcaseMediaProps} props - React properties passed from composition
 * @returns ShowcaseMedia
 */
export const ShowcaseMedia = function( props ){
  const { backgroundColor, logoImage, headline, ctaText, brandingImage, mediaAction, title } = props;
  const backgroundColorData = palette_variables[ backgroundColor ] || palette_variables[ 'neutral-100' ];

  if( !mediaAction ){
    return null;
  }

  return (
    <div className='ShowcaseMedia'>
      <Link_Huge action={ mediaAction } >
        <div className='ShowcaseMedia__header'
          style={ { backgroundColor: backgroundColorData } }
        >
          {
            logoImage && logoImage?.imageUrl &&
            <Image
              src={ logoImage?.imageUrl }
              alt={ title }
            />
          }
          <div className='ShowcaseMedia__header--content'>
            {
              headline &&
              <Text
                htmlTag='h3'
                textStyle='title-6'
                textAlign='center'
                ariaLabel={ headline }
              >
                { headline }
              </Text>
            }
            {
              ctaText &&
              <Button
                likeLink
                label={ ctaText }
                tabIndex={ -1 }
              />
            }
          </div>
        </div>
        {
          brandingImage && brandingImage?.imageUrl &&
          <div className='ShowcaseMedia__image'>
            <Image
              src={ brandingImage?.imageUrl }
            />
          </div>
        }
      </Link_Huge>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef ShowcaseMediaProps
 * @type {object}
 * @property {string} backgroundColor - Sets background color for ShowcaseMedia.
 * @property {object} logoImage - Sets logoImage property.
 * @property {string} headline - Sets the heading for ShowcaseMedia.
 * @property {string} ctaText - Sets text for ctaText.
 * @property {object} brandingImage - Sets brandingImage property.
 * @property {object} mediaAction - Sets mediaAction for ShowcaseMedia
 */
export const propTypes = {
  backgroundColor: PropTypes.string,
  logoImage: PropTypes.object,
  headline: PropTypes.string,
  ctaText: PropTypes.string,
  brandingImage: PropTypes.object,
  mediaAction: PropTypes.object
};

ShowcaseMedia.propTypes = propTypes;

export default ShowcaseMedia;